import React, { Fragment } from 'react';
import clsx from 'clsx';
import { Info2 as ExclamationCircle, View } from '@td-client-frontend/icons';
import { AddButton as FieldLabelButton } from '../AddButton';
import ReactTooltip from 'react-tooltip';

const getLabelTypeSettings = (labelBtn?: () => void, type?: string) => {
  const settings: Record<string, any> = {
    View: {
      fieldLabelClasses: 'justify-between',
      labelBtnIcon: <View />,
      fieldLabelBtnClasses: 'mb-1'
    },
    default: {
      fieldLabelClasses: labelBtn && !type ? 'justify-between' : 'flex-start'
    }
  };
  if (type && settings[type]) return settings[type];
  return settings.default;
};

export function FieldLabel({
  children,
  htmlFor,
  labelClasses,
  additionalLabelClasses,
  toolTip,
  labelBtn,
  labelBtnType,
  fieldLabelClasses,
  hideIcon = false,
  fieldLabelBtnClasses
}: {
  children: React.ReactNode;
  htmlFor?: string;
  labelClasses?: string;
  additionalLabelClasses?: string;
  toolTip?: string;
  labelBtn?: () => void;
  labelBtnType?: string;
  fieldLabelClasses?: string;
  hideIcon?: boolean;
  fieldLabelBtnClasses?: string;
}) {
  const fieldLabelTypeSettings = getLabelTypeSettings(labelBtn, labelBtnType);
  return (
    <div className={clsx('flex items-center', fieldLabelClasses, fieldLabelTypeSettings?.fieldLabelClasses)}>
      <label
        htmlFor={htmlFor}
        className={clsx(
          labelClasses || 'block text-sm font-bold tracking-wide font-effra text-black-default',
          children && 'mb-2',
          additionalLabelClasses
        )}
      >
        {children}
      </label>
      {labelBtn && (
        <FieldLabelButton
          onClick={labelBtn}
          label={labelBtnType || 'Add'}
          hideIcon={hideIcon}
          Icon={fieldLabelTypeSettings?.labelBtnIcon}
          extraClass={clsx(
            fieldLabelBtnClasses || 'pl-0 pr-0 pb-1 pt-0 h-4 border-b-0',
            fieldLabelTypeSettings?.fieldLabelBtnClasses
          )}
        />
      )}
      {toolTip && (
        <Fragment>
          <ExclamationCircle data-for={htmlFor} data-tip={toolTip} className='-mt-2 fill-current text-primary-500' />
          <ReactTooltip
            id={htmlFor}
            className='tooltip-custom'
            place='right'
            effect='solid'
            type='light'
            multiline
            border
            borderColor='#5b2f91'
          />
        </Fragment>
      )}
    </div>
  );
}
